/**
 * 视频章节信息
 */
class VideoChapter {
  /**
   * 章节编号
   */
  id = ''
  /**
   * 章节名称
   */
  name = ''
  /**
   * 上级章节编号
   */
  parentId = ''
  /**
   * 播放时间点，-1代表不参与播放，或许它就是用于展示章节结构的展示
   */
  timePoint: number
  /**
   * 排序
   */
  sort: number
}

export default VideoChapter
